export default __webpack_public_path__ + "images/7c4d4cdd377fe268a84306397cb896f3-indie_small.webp";